import { reuploadKycDocument } from '@basqet-dashboard/common/api';
import { Button, FormInput, Modal } from '@basqet-dashboard/common/components';
import { useKycInfo } from '@basqet-dashboard/common/hooks/queries';
import { formatErrorMessage, validateKycFileFormat } from '@basqet-dashboard/common/utils';
import PropTypes from 'prop-types';
import React from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

const ReUploadModal = ({ documentTitle, onModalClose, reference }) => {
  const { refetchKycInfo } = useKycInfo();

  const {
    control,
    register,
    handleSubmit,
    formState: { isSubmitting, isDirty }
  } = useForm({
    mode: 'onChange'
  });

  const reuploadDocument = async (data) => {
    const { file } = data;

    const validation = validateKycFileFormat(file);
    if (validation !== true) {
      toast.error(validation);
      return;
    }

    try {
      const requestBody = new FormData();
      await requestBody.append('file', file[0], file[0].name);
      await reuploadKycDocument(reference, requestBody);
      await refetchKycInfo();
      toast.success(`${documentTitle} successfully reuploaded`);
      setTimeout(() => {
        onModalClose();
      }, 2000);
    } catch (error) {
      formatErrorMessage(error);
    }
  };
  return (
    <Modal header={{ name: 'Reupload your', cursive: documentTitle }} onModalClose={onModalClose}>
      <div className="modal__form">
        <form onSubmit={handleSubmit(reuploadDocument)}>
          <FormInput
            type="file"
            control={control}
            name="file"
            id="file"
            register={register('file', {
              required: 'Kindly select a file',
              validate: (file) => {
                const validation = validateKycFileFormat(file);
                return validation === true || validation;
              }
            })}
            accept=".pdf,.jpg,.jpeg,.png"
          />
          <Button isFull disabled={!isDirty} isLoading={isSubmitting}>
            Upload
          </Button>
        </form>
      </div>
    </Modal>
  );
};

ReUploadModal.propTypes = {
  documentTitle: PropTypes.string,
  onModalClose: PropTypes.func,
  reference: PropTypes.string
};

export { ReUploadModal };
